// One fixed style per curated Model Book mark kind
// (docs/features/CURATED_MODEL_BOOK.md). Authors choose a KIND, never a
// colour: the vocabulary's one home is ChartMark::KINDS on the server, and
// this file is the one home for how each kind looks. The legend swatches on
// /model_book/:ticker are painted from here too, so the two cannot disagree.
//
// PROVENANCE BY STYLE (MODEL_BOOK_EVOLUTION.md §6 item 14): the detector's
// measured geometry is solid purple/orange (vcp_markup_overlay.js), AI marks
// are dashed teal (vcp_annotation_marks_overlay.js), and HUMAN marks are this
// third family — rose/magenta — so the three never collide on one chart.
// Don't move a human kind into teal or purple.

const FAMILY = Object.freeze({
  light: { strong: "#ad1457", main: "#d81b60", soft: "#c2185b", fill: "rgba(216, 27, 96, 0.10)" },
  dark:  { strong: "#f48fb1", main: "#f06292", soft: "#ec407a", fill: "rgba(240, 98, 146, 0.14)" }
})

export const MARK_FONT = "600 11px system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif"

// kind → style builder. `dash` is a canvas line dash ([] = solid).
const STYLE_BUILDERS = Object.freeze({
  base:         c => ({ stroke: c.main,   fill: c.fill, lineWidth: 1,   dash: [] }),
  contraction:  c => ({ stroke: c.strong, lineWidth: 2,   dash: [ 6, 4 ] }),
  level:        c => ({ stroke: c.soft,   lineWidth: 1.5, dash: [] }),
  breakout:     c => ({ stroke: c.main,   fill: c.main,  lineWidth: 1.5, dash: [] }),
  note:         c => ({ stroke: c.soft,   text: c.strong, lineWidth: 1, dash: [] }),
  volume_note:  c => ({ stroke: c.main,   lineWidth: 1.5, dash: [] }),
  volume_arrow: c => ({ stroke: c.strong, fill: c.strong, lineWidth: 1.5, dash: [] })
})

export const MARK_KINDS = Object.freeze(Object.keys(STYLE_BUILDERS))

// @param kind a ChartMark::KINDS key
// @param dark whether the dark theme is active
// @return {object|null} { stroke, fill?, text?, lineWidth, dash }
export function markStyle(kind, dark = false) {
  const build = STYLE_BUILDERS[kind]
  if (!build) return null
  return build(FAMILY[dark ? "dark" : "light"])
}

// The single colour a legend swatch shows for a kind.
export function swatchColor(kind, dark = false) {
  const style = markStyle(kind, dark)
  return style ? (style.fill && kind !== "base" ? style.fill : style.stroke) : null
}
